import React from 'react';
import Text from '../../Text';
import ActionsCardEngine from '../../../components/engine/ToggledActionsCardEngine';
import styled from 'styled-components/macro';

const NotificationCardView = ({
  id,
  description,
  disableToggle,
  hideToggle,
  isActive,
  onDelete,
  title,
  actionButtons,
  onToggleChange,
  onDisabledToggleClicked
}) => {
  return (
    <ActionsCardEngine
      disableToggle={disableToggle}
      hideToggle={hideToggle}
      id={id}
      title={title}
      isActive={isActive}
      actionButtons={actionButtons}
      buttonsAlwaysVisible
      onToggleChange={onToggleChange}
      onDisabledToggleClicked={onDisabledToggleClicked}
    >
      <Text variant="h2" content={title} />
      <Text content={description} />
    </ActionsCardEngine>
  );
};

export default NotificationCardView;
